import styled from '@emotion/styled';
import { designSystem } from '@/styles/theme';

/** 회원가입 전체 입력 기준: 기존 일반회원 밑줄형을 모든 가입 단계에 적용한다. */
export const SignupInput = styled.input<{ hasError?: boolean }>`
    width: 100%;
    padding: 14px 16px;
    border: none;
    border-bottom: 1px solid ${props => props.hasError ? '#dc2626' : '#e5e7eb'};
    border-radius: 0;
    font-size: 1rem;
    color: #1a1a1a;
    background-color: #fff;
    outline: none;
    transition: all 0.2s;
    box-sizing: border-box;

    &:focus {
        border-bottom-color: ${props => props.hasError ? '#dc2626' : designSystem.colors.primary};
    }

    &::placeholder {
        color: #9ca3af;
    }

    &:disabled {
        background-color: #f9fafb;
        color: #6b7280;
    }

    /* 크롬/네이버 패스워드 매니저 autofill 시 노랑/파랑 배경 제거 */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active,
    &:-internal-autofill-selected {
        -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
        box-shadow: 0 0 0 1000px #fff inset !important;
        -webkit-text-fill-color: #1a1a1a !important;
        background-color: #fff !important;
        background-image: none !important;
        transition: background-color 5000s ease-in-out 0s !important;
    }

    @media (max-width: 768px) {
        padding: 12px 14px;
        font-size: 0.95rem;
    }
`;

/** 날짜 트리거만 변경하며 팝업·달력 버튼은 유지한다. */
export const SignupDateInput = styled.div`
    > button, > div > button:first-of-type {
        border: none;
        border-bottom: 1px solid #e5e7eb;
        border-radius: 0;
        box-shadow: none;
    }
`;
/** 주소 검색 트리거만 가입 화면의 밑줄형으로 맞춘다. */
export const SignupAddressInput = styled.div`
    > div:first-of-type {
        border: none;
        border-bottom: 1px solid #e5e7eb;
        border-radius: 0;
    }
`;
